import { useDispatch } from 'react-redux';
import './App.css';
import Routing from './Routing/Routing';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Session from './Utils/Sessions';
import { updatePermissions } from './Store/AuthSlice/AuthSlice';
import { getData } from './API/GlobalApi';
import Notifier from './Utils/notify';
import { useEffect, useState } from 'react';
import SpinnerLoader from './Utils/Spinner';
import { QrProvider } from './Pages/ARCT/Context/QrContext';

function App() {


  const dispatch = useDispatch();
  const [isPermissionLoaded, setIsPermissionLoaded] = useState(false);
  const token = Session.get('token');
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await getData('core/get-auth-user-permissions/');

        if (response?.permissions) {
          dispatch(updatePermissions({ permissions: response.permissions }));
        } else {
        
            Notifier.error('No permissions found');
            Session.remove('token');
            window.location.href = '/login';
        }
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
      } finally {
        setIsPermissionLoaded(true); // mark as done (success or fail)
      }
    };

    if (token) {
      fetchPermissions();
    } else {
      setIsPermissionLoaded(true); // even if no token, mark done
    }
  }, [dispatch, token]);



  // ⏳ Wait until permissions are loaded
  if (!isPermissionLoaded) {
    return (
      <div style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        <SpinnerLoader />
      </div>
    );
  }


  return (
    <BrowserRouter>
      <ToastContainer />
      <QrProvider>

        <Routing />
      </QrProvider>
    </BrowserRouter>
  );
}

export default App;
